import { useEffect, useState } from 'react';
import { toFa } from '../../utils/faFormat';
import { fieldFinance } from '../../lib/installerFinanceApi';
import './workFinance.css';
export function StatementList({ settlements = [] }) {
  return <section className="work-finance" dir="rtl"><h3>صورت‌وضعیت کارکرد</h3><p>فقط محاسبه کارکرد؛ پرداخت وجه انجام نمی‌شود. مبالغ به ریال هستند.</p>
    {!settlements.length && <p>صورت‌وضعیتی ثبت نشده است.</p>}
    {settlements.map((s) => <article key={s.id} className="finance-card"><strong>کار {toFa(s.job_id)}</strong>
      <p>{s.provisional ? 'برآورد موقت، غیرقابل پرداخت تا تأیید متراژ' : 'محاسبه با نرخ‌های ثابت‌شده'}</p>
      <p>ناخالص: {toFa(s.gross_irr)} | حسن انجام کار ({toFa(s.retention_pct)}٪): {toFa(s.retention_irr)} | خالص: {toFa(s.net_irr)}</p>
      <p>{s.status === 'retention_released' ? 'حسن انجام کار با تحویل قطعی آزاد شده است' : s.civil_part_id ? 'حسن انجام کار تا تحویل قطعی منطقه نگهداری می‌شود' : 'در انتظار تصمیم آزادسازی'}</p>
      <p>ذی‌نفع: {s.beneficiary_type === 'contractor' ? 'شرکت پیمانکار' : 'نیروی اجرایی'} {toFa(s.beneficiary_id)}</p>
      <ul>{s.lines.map((l, i) => <li key={i}>{l.name_fa}: {toFa(l.qty)} {l.unit} × {toFa(l.unit_price_irr)} = {toFa(l.total_irr)} ریال</li>)}</ul>
    </article>)}
  </section>;
}
function CustomerRatings({ ratings }) {
  if (!ratings) return null;
  return ratings.count ? <p>رضایت تأییدشدهٔ مشتریان: {toFa(ratings.average)} از ۵ ({toFa(ratings.count)} نظر)</p>
    : <p>هنوز نظر تأییدشده‌ای ثبت نشده است.</p>;
}
export function ScoreBreakdown({ score }) {
  if (!score) return null;
  const rows = score.installers || [score];
  return <section className="work-finance" dir="rtl"><h3>جزئیات امتیاز کیفیت</h3>
    <p>دوباره‌کاری: رد انسانی هر ارسال، وزن پیش‌فرض ۳ امتیاز. خطای هوش مصنوعی، تلاش مجدد و توقف بدون تقصیر محاسبه نمی‌شوند. هشدارها خنثی هستند.</p>
    {score.installers && <p>میانگین وزنی کارهای تکمیل‌شده در ۱۸۰ روز اخیر بر اساس مسئولیت تاریخی شرکت؛ نیروی بدون کار کنار گذاشته می‌شود.</p>}
    <CustomerRatings ratings={score.customer_ratings} />
    <p>رضایت مشتریان جداگانه گزارش می‌شود، بدون تأثیر بر امتیاز کیفیت.</p>
    <ul>{rows.map((r, i) => <li key={r.id || i}>{r.full_name || 'نیروی اجرایی'}: {toFa(r.score)} از ۱۰۰ {r.completed_jobs != null && `(${toFa(r.completed_jobs)} کار)`}
      {r.breakdown && <span> | کیفیت: {toFa(r.breakdown.quality)}، تعهد معوق: {toFa(r.breakdown.concession_overdue)}، تأخیر: {toFa(r.breakdown.delay)}، دوباره‌کاری: {toFa(r.breakdown.rework)}</span>}{score.installers && <CustomerRatings ratings={r.customer_ratings} />}</li>)}</ul>
  </section>;
}
export function CompanyStatements({ token }) {
  const [data, setData] = useState(null); const [error, setError] = useState('');
  useEffect(() => {
    const ctrl = new AbortController(); setData(null); setError('');
    fieldFinance(token, 'contractor/work-statements', { signal: ctrl.signal }).then((d) => { if (!ctrl.signal.aborted) setData(d); }).catch((e) => { if (!ctrl.signal.aborted) setError(e.message); });
    return () => ctrl.abort();
  }, [token]);
  return <div className="inst-card">{error && <p role="alert">{error}</p>}{data ? <StatementList settlements={data.settlements} /> : !error && <p>در حال دریافت صورت‌وضعیت...</p>}</div>;
}
